import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Card, CardBody, Row, Col, CardFooter, Progress } from "shards-react";
import { FaAndroid, FaApple } from "react-icons/fa"; // Import icons
import "./loaderStyles.css"; // Import the loader styles
import { useAuth } from '../../context/AuthContext';
const UserStats1 = ({ smallStats, os }) => {
  const [manufacturerData, setManufacturerData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [hasData, setHasData] = useState(false); // New state to track if data is valid
  const { logout } = useAuth(); 
  useEffect(() => {
    const fetchData = async () => {
      const companyId = localStorage.getItem('company_id');
      const token = localStorage.getItem("token");
      if(!companyId||companyId==''||!token||token==''){ 
        setIsLoading(false);
        logout();
        return;
      }

      setIsLoading(true);
      try {
        const response = await fetch("https://vaptlabreport.com/shieldapi/top_manufacturer.php", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ company_id: companyId, os }),
        });

        const data = await response.json();
        if (data && data.status === "success" && data.data.length > 0) {
          setManufacturerData(data.data);
          setHasData(true); // Set to true if valid data is received
        } else {
          console.error("Error fetching manufacturer data:", data.message);
          setHasData(false);
        }
      } catch (error) {
        console.error("API fetch error:", error);
        setHasData(false);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [os]);

  const renderIcon = () => {
    if (os === "android") return <FaAndroid style={{ color: "#3ddc84", marginRight: "8px" }} />;
    if (os === "ios") return <FaApple style={{ color: "#000", marginRight: "8px" }} />;
    return null;
  };

  if (!hasData && !isLoading) return null; // Don't render the card if no data and not loading

  return (
    <Card small className="user-stats mb-4">
      <CardBody>
        <Row>
          <Col lg="12" md="12" sm="12" className="mb-3">
            <div style={{ marginLeft: "15px", textAlign: "left", fontWeight: "bold" }}>
              <h6 className="m-0">
                {renderIcon()} {/* Add icon here */}
                {smallStats[0].value}
              </h6>
            </div>
          </Col>
        </Row>
      </CardBody>
      <CardFooter className="py-0">
        <Row>
          {isLoading ? (
            <div className="spinner" style={{ margin: "20px auto" }}></div>
          ) : (
            manufacturerData.map((item, idx) => (
              <Col key={idx} sm="12" className="border-top pb-3 pt-2">
                <div className="progress-wrapper" style={{ marginLeft: "15px" }}>
                  <div className="progress-label">{item.model}</div>
                  <Progress className="progress-sm" value={item.percentage} striped>
                    <span className="progress-value">{item.percentage}%</span>
                  </Progress>
                </div>
              </Col>
            ))
          )}
        </Row>
      </CardFooter>
    </Card>
  );
};

UserStats1.propTypes = {
  smallStats: PropTypes.array,
};

UserStats1.defaultProps = {
  smallStats: [
    {
      value: "Top Device Models in threats",
    },
  ],
};

export default UserStats1;
